import 'sharer.js';
import Popup from './popup';

document.addEventListener('DOMContentLoaded', () => {
  const popup = new Popup();
  document.addEventListener('click', (e) => {
    if (e.target
            && e.target.closest('.share')
    ) {
      e.preventDefault();
      const trigger = e.target.closest('.share');
      let shareLink = window.location.href;
      if (trigger.getAttribute('data-link')) {
        shareLink = trigger.getAttribute('data-link');
      }
      if (window.innerWidth < 800) {
        navigator.share({
          url: shareLink,
        });
      } else {
        if (trigger.getAttribute('data-title')) {
          document.querySelector('.alertShare .title3').textContent = trigger.getAttribute('data-title');
        }
        document.querySelector('.alertShare .input-copy input[type="text"]').value = shareLink;
        document.querySelectorAll('.alertShare [data-url]')
          .forEach((el) => {
            el.setAttribute('data-url', shareLink);
          });
        popup.open('.alertShare');
      }
    }
  });
});
